import { resolveText } from '../../i18n/resolveText';
import { getHashParams } from '../../dsl/hashParams';
import { verifyMagicLink, getSession } from '../../api/authApi';
import { authService } from '../../auth/AuthService';
import { i18nService } from '../../i18n/I18nService';
function errorMessageFor(block, reason) {
    if (reason === 'expired')
        return block.errorExpired;
    if (reason === 'used')
        return block.errorUsed;
    return block.errorInvalid;
}
export function renderAuthVerify(block) {
    const section = document.createElement('section');
    section.className = 'auth';
    const message = document.createElement('p');
    message.className = 'auth__desc';
    message.textContent = resolveText(block.verifying);
    section.appendChild(message);
    function showError(textKey) {
        section.innerHTML = '';
        const error = document.createElement('p');
        error.className = 'auth__error';
        error.textContent = resolveText(textKey);
        const backLink = document.createElement('a');
        backLink.className = 'cta auth__submit';
        backLink.href = '#page=home';
        backLink.textContent = resolveText(block.backHomeLabel);
        section.append(error, backLink);
    }
    const params = getHashParams();
    const token = params.get('token');
    if (!token) {
        showError(block.errorInvalid);
        return section;
    }
    verifyMagicLink(token, i18nService.getLocale())
        .then(async (result) => {
        if (!result.ok) {
            showError(errorMessageFor(block, result.reason));
            return;
        }
        const session = await getSession();
        authService.setAuthenticated(session.user ?? null);
        const rawPlaceId = params.get('place');
        const fallbackPlaceId = rawPlaceId !== null && rawPlaceId !== '' ? Number(rawPlaceId) : null;
        const placeId = result.placeId ?? fallbackPlaceId;
        if (placeId !== null && Number.isInteger(placeId)) {
            window.location.hash = `#page=booking&place=${placeId}`;
        }
        else {
            window.location.hash = '#page=profile';
        }
    })
        .catch((error) => {
        console.error('Failed to verify magic link:', error);
        showError(block.errorInvalid);
    });
    return section;
}
